import React from 'react'
import { FormHelperText, Grid, InputLabel } from '@mui/material'
import { Controller } from 'react-hook-form';
import { TagInput } from 'rsuite';
import "./InputTag.css";

const InputTag = ({ xs, name, control, label, disabled, rules = {}, required, placeholder }) => {
  return (
    <>
      <Grid
        item
        xs={xs}
        alignContent="center"
        justifyContent={"center"}
        style={{ width: '100%' }}
      >
        <Controller
          name={name}
          control={control}
          rules={!disabled && {
            ...rules,
            required
          }}
          render={({
            field: { value, onChange },
            fieldState: { error },
          }) => (
            <>
              <InputLabel sx={{ mb: 1 }}>{label}</InputLabel>
              <TagInput
                trigger={['Enter', 'Space', 'Comma']}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                width={'100%'}
                className='input-tag'
                style={{
                  border: '1px solid #041C3F',
                  width: '100%',
                }}
              />
              {
                error && (
                  <FormHelperText sx={{ color: "#d32f2f" }}>
                    {required}
                  </FormHelperText>
                )
              }
            </>
          )}
        />
      </Grid >
    </>
  )
}

export default InputTag